import { render, staticRenderFns } from "./ManageCoupons.vue?vue&type=template&id=977d3390&scoped=true&"
import script from "./ManageCoupons.vue?vue&type=script&lang=js&"
export * from "./ManageCoupons.vue?vue&type=script&lang=js&"
import style0 from "./ManageCoupons.vue?vue&type=style&index=0&id=977d3390&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977d3390",
  null
  
)

export default component.exports